// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".errorPage[data-v-49d7fff8]{background:#715a30;height:100%}.errorPage__template[data-v-49d7fff8]{align-items:center;display:flex;flex-direction:column;height:100%;justify-content:center}.errorPage__template h2[data-v-49d7fff8]{color:#a88c59;font-size:6rem}.errorPage__template p[data-v-49d7fff8]{color:#d2b887;font-size:1.2rem;margin-top:2rem}.errorPage__template p+p[data-v-49d7fff8]{margin-top:2rem}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
